'use strict';

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPasswordValidationRules = exports.passwordValidationRules = exports.differentDigitsValidator = exports.noDigitsSequenceValidator = exports.RuleKey = void 0;
var DEFAULT_MIN_LENGTH = 8;
var DEFAULT_MAX_LENGTH = 25; // 25 is the limit in the GiG Core database
var RuleKey;
(function (RuleKey) {
    RuleKey["minLength"] = "min-length";
    RuleKey["maxLength"] = "max-length";
    RuleKey["minMaxLength"] = "min-max-length";
    RuleKey["number"] = "number";
    RuleKey["symbol"] = "symbol";
    RuleKey["uppercase"] = "uppercase";
    RuleKey["lowercase"] = "lowercase";
    RuleKey["numbersOnly"] = "numbers-only";
    RuleKey["differentDigits"] = "different-digits";
    RuleKey["noDigitsSequence"] = "no-digits-sequence";
})(RuleKey = exports.RuleKey || (exports.RuleKey = {}));
function noDigitsSequenceValidator(password) {
    var pattern = '0123456789012345789';
    var reversePattern = '9875432109876543210';
    if ((password === null || password === void 0 ? void 0 : password.length) === 1) {
        // not a sequence
        return true;
    }
    return (pattern.indexOf(password) === -1 &&
        reversePattern.indexOf(password) === -1);
}
exports.noDigitsSequenceValidator = noDigitsSequenceValidator;
function differentDigitsValidator(password) {
    return !/^(.)\1+$/.test(password);
}
exports.differentDigitsValidator = differentDigitsValidator;
exports.passwordValidationRules = (_a = {},
    _a[RuleKey.minLength] = function (param) {
        if (param === void 0) { param = DEFAULT_MIN_LENGTH; }
        return function (password) {
            return !!password && password.length >= param;
        };
    },
    _a[RuleKey.maxLength] = function (param) {
        if (param === void 0) { param = DEFAULT_MAX_LENGTH; }
        return function (password) {
            return !!password && password.length <= param;
        };
    },
    _a[RuleKey.minMaxLength] = function (param) {
        if (param === void 0) { param = {}; }
        return function (password) {
            var _a, _b;
            var min = (_a = param.min) !== null && _a !== void 0 ? _a : DEFAULT_MIN_LENGTH;
            var max = (_b = param.max) !== null && _b !== void 0 ? _b : DEFAULT_MAX_LENGTH;
            return (!!password && password.length >= min && password.length <= max);
        };
    },
    _a[RuleKey.number] = function () { return function (password) { return /[0-9]/.test(password); }; },
    _a[RuleKey.symbol] = function () { return function (password) {
        return /[ \!"#\$%&'\(\)\*\+,\-\.\/\:;\<\=\>\?@\[\]\^_`\{\|\}~]/.test(password);
    }; },
    _a[RuleKey.uppercase] = function () { return function (password) { return /[A-Z]/.test(password); }; },
    _a[RuleKey.lowercase] = function () { return function (password) { return /[a-z]/.test(password); }; },
    _a[RuleKey.numbersOnly] = function () { return function (password) {
        return /^[0-9]*$/.test(password);
    }; },
    _a[RuleKey.differentDigits] = function () { return differentDigitsValidator; },
    _a[RuleKey.noDigitsSequence] = function () { return noDigitsSequenceValidator; },
    _a);
/**
 * Gets password validation rules
 * Accepts an array of conditions ['min-length', 'uppercase', 'lowercase', 'number', 'symbol'].
 * The array can also contain advanced conditions, defined in the following way:
 * [{name:'min-length', value:8}, {name:'max-length', value:10}]
 * By default it will be every condition.
 * @example "['length', 'uppercase', {name:'max-length', value:10}]"
 *
 * @param passwordValidationConditions An array of validation methods to use.
 */
function getPasswordValidationRules(passwordValidationConditions) {
    return passwordValidationConditions.reduce(function (result, currRule) {
        if (typeof currRule === 'object' &&
            exports.passwordValidationRules[currRule.name]) {
            var rule = exports.passwordValidationRules[currRule.name](currRule.value);
            if (rule) {
                result[currRule.name] = rule;
            }
        }
        else {
            var rule = exports.passwordValidationRules[currRule]();
            if (rule) {
                result[currRule] = rule;
            }
        }
        return result;
    }, {});
}
exports.getPasswordValidationRules = getPasswordValidationRules;
